<template>
  <div class="wrap">
    <div class="top" v-show="!isRfs">
      <i class="el-icon-back" @click="fanhui"></i>
      <span class="title">{{ title }}</span>
      <span style="width:20px"></span>
    </div>
    <div class="top2" v-if="info != null">
      <div id="mp4" class="box" v-show="player != null"></div>
      <div class="fengmian display_center" v-show="player == null" :style="'background-image: url(' + info.coverpicture + ');'">
        <img src="../../assets/img/bofang.png" @click="toPlay" alt="" />
      </div>
    </div>
    <!-- <div class="every"></div> -->
    <div class="nav">
      <div class="navbox" style="color:#0b8586;border-color:#0b8586">自训课程({{ courseList.length }})</div>
    </div>
    <div class="bot">
      <div class="bot2">
        <div class="b2box display_column" v-for="(item, index) in courseList" :style="index == 0 ? 'border-top:none' : ''" @click="toCourse(item)" :key="index">
          <div class="display_between_nocenter">
            <div class="blb2title" :style="item.id == $route.query.cid ? 'color: #e60012;' : ''">
              <span>{{ item.title }}</span>
            </div>
            <div class="blb2bq" v-show="(item.isApply && !info.isPurchase) && !((info.discountStatus == 2 && uid != 0) || (info.discountStatus == 1 && userType != 0) || (info.discountStatus == 3 && userType == 1))" style="color: #fff; background: #e60012; border: 1px solid #e60012">
              <span>试看</span>
            </div>
            <div class="blb2bq" :style="item.id == $route.query.cid ? 'border: 1px solid #e60012;color:#e60012' : ''">
              <span>视频</span>
            </div>
          </div>
          <div class="blb2tech">
            <span>机构：{{ orgName }}</span>
          </div>
          <div class="blb2time display_center_ud" v-show="item.res_Type != 4">
            <span style="font-weight: 800">{{ item.standingtime == 0 ? '0:00' :
              item.standingtime.toFixed(2).toString().replace('.', ':')
            }}</span>
            <div>/</div>
            <span>{{ item.res_duration.toFixed(2).toString().replace('.', ':') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Player from 'xgplayer';
import { Dialog } from 'vant';
export default {
    data() {
        return {
            courseList: [],
            cid: 0,
            uid: 0,
            orgid: 0,
            title: '课程详情',
            orgName: '',
            isBofang: false,
            player: null,
            info: null,
            stime: 0,
            isRfs: false,
        };
    },
    created() {
        if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query, 'tokenkey')) {
            let tok = this.$route.query.tokenkey;
            this.httphelper
                .post('/api/LoginApi/CheckToken', {
                    tokenKey: tok,
                })
                .then(res => {
                    if (res.data.code == 200) {
                        localStorage.setItem('nickname', res.data.data.nickname);
                        var aData = new Date();
                        var CurrentDategetTime = 0;
                        var VipEdDategetTime = 0;
                        if (res.data.data.memberDate.m_EndDate) {
                            var CurrentDate = aData.getFullYear() + '-' + (aData.getMonth() + 1) + '-' + aData.getDate() + ' ' + aData.getHours() + ':' + aData.getMinutes() + ':' + aData.getSeconds();
                            var VipEdDate = res.data.data.memberDate.m_EndDate;
                            CurrentDategetTime = new Date(CurrentDate.replace(/-/g, '/')).getTime() / 1000;
                            VipEdDategetTime = new Date(VipEdDate.replace(/-/g, '/')).getTime() / 1000;
                        }
                        if (res.data.data.memberDate.m_EndDate == null || parseInt(CurrentDategetTime) - parseInt(VipEdDategetTime) >= 0) {
                            this.userType = 0;
                        } else {
                            if (res.data.data.memberDate.m_Type == 1) {
                                this.userType = 1;
                            } else if (res.data.data.memberDate.m_Type == 2) {
                                this.userType = 2;
                            } else {
                                this.userType = 0;
                            }
                        }
                        localStorage.setItem('userType', this.userType);
                        localStorage.setItem('ResData', JSON.stringify(res.data.data));
                        this.$cookies.set('token_chinagp', tok);
                        this.uid = Number(res.data.data.id);
                        this.cid = Number(this.$route.query.cid);
                        this.orgid = Number(this.$route.query.orgid);
                        this.getOrgName();
                        this.GetCourseList();
                        this.getMp4();
                    } else {
                        Dialog.alert({
                            title: '提示',
                            message: '请先登录',
                        }).then(() => {
                            let callback = encodeURIComponent(window.location.href);
                            window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
                        });
                    }
                });
        } else if (this.$cookies.isKey('token_chinagp') && this.$cookies.get('token_chinagp') != null && this.$cookies.get('token_chinagp') != '' && this.$cookies.get('token_chinagp') != 'null') {
            this.uid = Number(JSON.parse(localStorage.getItem('ResData')).id);
            this.cid = Number(this.$route.query.cid);
            this.orgid = Number(this.$route.query.orgid);
            this.getOrgName();
            this.GetCourseList();
            this.getMp4();
        } else {
            Dialog.alert({
                title: '提示',
                message: '请先登录',
            }).then(() => {
                let callback = encodeURIComponent(window.location.href);
                window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
            });
        }
    },
    watch: {
        $route: {
            handler() {
                if (this.$route.query.cid && this.$route.query.cid != this.cid) {
                    this.cid = Number(this.$route.query.cid);
                    this.getMp4();
                    this.GetCourseList();
                }
            },
            deep: true,
        },
    },
    mounted() {
        window.addEventListener('beforeunload', () => {
            if (this.player) this.toRecordMp4();
        });
        window.addEventListener('onunload', () => {
            if (this.player) this.toRecordMp4();
        });
        window.addEventListener('unload', () => {
            if (this.player) this.toRecordMp4();
        });
        window.addEventListener(
            'popstate',
            () => {
                if (this.player) this.toRecordMp4();
                //判断全屏状态返回
                if (this.player && this.isRfs) {
                    var time = setTimeout(function () {
                        //   if (url.indexOf("&isRfs=true") != -1) window.location.href = url
                        //   else window.location.href = url + '&isRfs=true'
                        window.location.href = url;
                        clearTimeout(time);
                    }, 100);
                }
            },
            false
        );
    },
    beforeDestroy() {
        if (this.player) this.toRecordMp4();
    },
    destroyed() {
        window.removeEventListener('beforeunload', this.toRecordMp4);
        window.removeEventListener('unload', this.toRecordMp4);
        window.removeEventListener('onunload', this.toRecordMp4);
    },
    methods: {
        fanhui() {
            window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/user/institutions?tokenkey=' + this.$cookies.get('token_chinagp');
        },
        GetCourseList() {
            this.httphelper
                .get('/api/EnterpriseApi/GetUserIntCourseList', {
                    orgid: this.orgid,
                    userId: this.uid,
                })
                .then(res => {
                    if (res.code == 200) {
                        this.courseList = res.data;
                        for (let i = 0; i < res.data.length; i++) {
                            if (res.data[i].id == this.cid) {
                                this.title = res.data[i].title;
                            }
                        }
                        if (this.title == '课程详情') {
                            Dialog.alert({
                                title: '提示',
                                message: '暂无此课程',
                            }).then(() => {
                                window.location.href = this.httphelper.IsDebugH5GP519();
                            });
                        }
                    }
                });
        },
        getOrgName() {
            this.httphelper
                .get('/api/CGPEnterPriseApi/GetGpOrganInfoById', {
                    id: this.orgid,
                })
                .then(res => {
                    if (res.code == 200) {
                        this.orgName = res.data.org_name;
                    }
                });
        },
        getMp4() {
            this.stime = 0;
            if (this.player) {
                this.player.destroy();
                this.player = null;
                this.httphelper
                    .post('/api/EnterpriseApi/GetIntCourseDeta', {
                        courseId: this.cid,
                        userId: this.uid,
                    })
                    .then(res => {
                        if (res.data.code == 200) {
                            this.info = res.data.data;
                            this.toPlay();
                        }
                    });
            } else {
                this.httphelper
                    .post('/api/EnterpriseApi/GetIntCourseDeta', {
                        courseId: this.cid,
                        userId: this.uid,
                    })
                    .then(res => {
                        if (res.data.code == 200) {
                            this.info = res.data.data;
                        }
                    });
            }
        },
        toPlay() {
            let minute = Number(this.info.standingtime.toFixed(2).split('.')[0]) * 60;
            let second = Number(this.info.standingtime.toFixed(2).split('.')[1]);
            let starTime = minute + second;
            let ignores = this.info.isFastForward ? [] : ['progress'];
            this.player = new Player({
                id: 'mp4',
                url: this.info.resUrl,
                autoplay: true,
                playsinline: true,
                width: '100%',
                height: '100%',
                lastPlayTime: starTime,
                ignores: ignores,
                rotateFullscreen: true,
                'x5-video-player-type': 'h5',
                'x5-video-orientation': 'portraint',
                playbackRate: [0.5, 1, 1.5, 2, 3],
            });
            this.player.on('ended', () => {
                this.toRecordMp4();
            });
            this.player.on('pause', () => {
                this.isBofang = false;
            });
            this.player.on('playing', () => {
                this.isBofang = true;
            });
            this.player.on('getRotateFullscreen', () => {
                this.isRfs = true;
            });
            this.player.on('exitRotateFullscreen', () => {
                this.isRfs = false;
            });
            this.player.on('timeupdate', e => {
                var soupttime = parseInt(e.currentTime / 60) + Math.ceil(e.currentTime % 60) / 100;
                if (this.stime != soupttime) {
                    this.stime = soupttime;
                }
            });
        },
        toRecordMp4() {
            if (this.stime == 0 || this.uid == 0) return;
            var img = document.createElement('img');
            img.src = this.httphelper.get('/api/EnterpriseApi/UpdIntCourseRecord', {
                courseid: this.cid,
                userId: this.uid,
                standingtime: this.stime,
            });
            document.body.appendChild(img);
            this.stime = 0;
            this.GetCourseList();
            img.style.display = 'none';
        },
        toCourse(item) {
            if (item.id == this.cid) return;
            if (this.player) this.toRecordMp4();
            this.$router.push({
                path: '/mcourse',
                query: {
                    cid: item.id,
                    orgid: this.orgid,
                },
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.top {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 46px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    z-index: 3000;
    background-color: #fff;

    .el-icon-back {
        font-size: 20px;
    }

    .title {
        flex: 1;
        margin: 0 10px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
        line-height: 14px;
    }
}

.top2 {
    padding-top: 46px;

    .box {
        width: 100%;
        height: 210px;

        ::v-deep .xgplayer-replay {
            z-index: 10;
        }
    }

    .fengmian {
        width: 100%;
        height: 210px;
        background-size: 100% 100%;
        image-rendering: -moz-crisp-edges;
        image-rendering: -o-crisp-edges;
        image-rendering: -webkit-optimize-contrast;
        image-rendering: crisp-edges;
        -ms-interpolation-mode: nearest-neighbor;
    }
}

.every {
    width: 100%;
    height: 10px;
    background: #f6f7fb;
}

.nav {
    display: flex;
    margin: 4px 2px 0;
    overflow-x: scroll;

    .navbox {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #000000;
        line-height: 46px;
        margin: 0 15px;
        white-space: nowrap;
        border-bottom: 2px solid #ffffff;
    }
}

.nav::-webkit-scrollbar {
    display: none;
}

.bot {
    border-top: 1px solid #eeeeee;
    margin: 0 10px 60px;

    .bot2 {
        margin: 5px 7px 0;

        .b2box {
            padding: 16px 0;
            border-top: 1px solid #eee;
        }

        .blb2title {
            flex: 1;
            font-size: 15px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #000000;
            line-height: 20px;
            margin-right: 3px;
        }

        .blb2bq {
            height: 18px;
            background: #ffffff;
            border: 1px solid #999999;
            border-radius: 9px;
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            line-height: 17px;
            padding: 0 5px;
            margin-left: 5px;
            margin-top: 2px;
        }

        .blb2tech {
            font-size: 11px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #b1b1b1;
            line-height: 15px;
            margin: 10px 0;
        }

        .blb2time {
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #000000;
            line-height: 12px;

            div {
                margin: 0 2px;
            }

            img {
                width: 11px;
                height: 11px;
                margin-left: 5px;
            }
        }
    }
}
</style>